import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/unitSlice";
import unitApis from "src/api/unit";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Create Unit Saga
function* CreateUnitSaga({
  payload,
}: ReturnType<typeof actions.createUnitRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      unitApis.createUnit,
      payload
    );
    yield put(actions.createUnitSuccess(response));
  } catch (error) {
    yield put(
      actions.createUnitError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Unit List Saga
function* GetUnitListSaga({
  payload,
}: ReturnType<typeof actions.getUnitListRequest> & {
  payload: {
    page?: number;
    limit: number;
    search?: string;
    status?: "active" | "inactive";
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      unitApis.getUnitList,
      payload
    );
    yield put(actions.getUnitListSuccess(response));
  } catch (error) {
    yield put(
      actions.getUnitListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Edit Unit Saga
function* EditUnitSaga({
  payload,
}: ReturnType<typeof actions.editUnitRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      unitApis.editUnit,
      payload
    );
    yield put(actions.editUnitSuccess(response));
  } catch (error) {
    yield put(
      actions.editUnitError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Delete Unit Saga
function* DeleteUnitSaga({
  payload,
}: ReturnType<typeof actions.deleteUnitRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      unitApis.deleteUnit,
      payload
    );
    yield put(actions.deleteUnitSuccess(response));
  } catch (error) {
    yield put(
      actions.deleteUnitError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* unitSaga() {
  yield all([
    takeEvery(actions.createUnitRequest, CreateUnitSaga),
    takeEvery(actions.getUnitListRequest, GetUnitListSaga),
    takeEvery(actions.editUnitRequest, EditUnitSaga),
    takeEvery(actions.deleteUnitRequest, DeleteUnitSaga),
  ]);
}
